import { Component, OnInit } from '@angular/core';
import { RepurchaseService } from '../../../repurchase/services/repurchase.service';
import { SaleService } from '../../../sales/services/sale.service';
import { SaleReturnService } from '../../../salesreturn/services/sale-return.service';
import { StockStatsService } from '../../services/stockstats.service';
import { StatsService } from '../../services/stats.service';
import { RepurchaseRenewalService } from '../../../repurchase/services/repurchase-renewal.service';
import { TechnicalserviceService } from '../../../technicalservice/services/technicalservice.service';
import { PurchaseService } from '../../../purchase/services/purchase.service';
import { ExpensesService } from '../../../expenses/services/expenses.service';
import { ExpectedExpensesService } from '../../../expenses/services/expected-expenses.service';
import { RepurchaseWithdrawalTicketService } from '../../../repurchase/services/repurchase-withdrawal-ticket.service';

import * as moment from 'moment/moment';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.css'],
  providers: [StatsService,RepurchaseService,SaleService,SaleReturnService,StockStatsService,RepurchaseRenewalService, TechnicalserviceService, PurchaseService, ExpensesService,ExpectedExpensesService,RepurchaseWithdrawalTicketService]
})
export class StatsComponent implements OnInit {

    totalRepurchases:number = 0;
    totalRepurchasesAmountPaid:number = 0;
    fromDate:any = "01-01-2015";
    untilDate:any;
    saleFilter:any = {
        fromDate: moment().format("DD-MM-YYYY"),
        untilDate: moment().add(1,'days').format('DD-MM-YYYY')
    }
    revenueFilter:any = {
        fromDate: moment().format("DD-MM-YYYY"),
        untilDate: moment().add(1,'days').format('DD-MM-YYYY')
    }
    saleResume:any = {
        shopsTotal: 0,
        totalByShop: [],
        totalByShopAndUserPaymentMethod: []
    }
    saleReturnResume:any = {
        shopsTotal: 0,
        totalByShop: [],
        totalByShopAndUser: []
    }
    stockDate:any = moment().subtract(1, "days").format("YYYY-MM-DD");
    totals:any ={
        number_of_products:0,
        total_invested:0,
        total_expected_sales:0
    }
    stockStats:any;
    revenueResume:any = {
        shopsTotal: 0,
        totalByShop: [],
        totalByShopAndUser: []
    }
    expensesResume:any = {
        shopsTotal: 0,
        totalByShop: [],
        totalByShopAndUser: []
    }
    generalShopKeys: any = [];
    selectYear:any = moment().year();
    totalRevenueExpensesByTrimester:any;
    totalRevenueExpensesWithoutExpectedExpenses:any;
    trimestersOptions:any = [
        {id:1,name:"Enero-Marzo"},
        {id:2,name:"Abril-Junio"},
        {id:3,name:"Julio-Septiembre"},
        {id:4,name:"Octubre-Diciembre"},
    ]
    selectedTrimester:any = 1;
    constructor(private repurchaseService: RepurchaseService, private saleService:SaleService, private saleReturnService:SaleReturnService, 
        private stockStatsService:StockStatsService, private repurchaseRenewalService:RepurchaseRenewalService, private technicalServiceService:TechnicalserviceService,
        private expensesService:ExpensesService, private purchaseService:PurchaseService, private expectedExpensesService:ExpectedExpensesService,
        private repurchaseWithdrawalTicketService:RepurchaseWithdrawalTicketService, private StatsService:StatsService) { }

    ngOnInit() {
        this.getRepurchases();
        this.getSales();
        this.getReturnSales();
        this.getStockStats(this.stockDate);
        this.getRevenue();
        this.getExpenses();
        this.getTotalRevenueAndExpensesByTrimester();
    }
    
    getFilter(){
        this.getRepurchases();
    }

    getRepurchases(){
        this.totalRepurchases = 0;
        this.totalRepurchasesAmountPaid = 0; 
        var params = {
            where: { status: ['Vigente', 'Fuera de fecha']}
        };
        if ((this.fromDate && moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date') || (this.untilDate && moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date')){
            params.where['init_date'] = {};
        }
        if (this.fromDate && moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
            params.where['init_date'][">="] = moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        }
        if (this.untilDate && moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
            params.where['init_date']["<="] = moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        }
        this.repurchaseService.query(params)
        .subscribe((repurchases) => {
            this.totalRepurchases  = repurchases.length;
            console.log(this.totalRepurchases)
            repurchases.forEach(r => {
                this.totalRepurchasesAmountPaid += r.total_purchase_amount;
            });
            console.log(this.totalRepurchasesAmountPaid)
        });
    }

    calculateSalesResume(){
        this.getSales();
        this.getReturnSales();
    }

    getSales(){
        this.saleResume = {
            shopsTotal: 0,
            totalByShop: [],
            totalByShopAndUserPaymentMethod: []
        }
        var params = {
            createdAtFrom:null,
            createdAtUntil: null
        }
        if (this.saleFilter.fromDate && moment(this.saleFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
            params.createdAtFrom = moment(this.saleFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        }
        if (this.saleFilter.untilDate && moment(this.saleFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
            params.createdAtUntil = moment(this.saleFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        }
        this.StatsService.getRevenueSaleAndMethod(params)
        .subscribe((sales) => {
            console.log(sales)
            sales.forEach((s)=>{
                this.saleResume.shopsTotal += s.total;
                this.saleResume.shopsTotal = this.roundValue(this.saleResume.shopsTotal);
                this.saleResume.totalByShop[s.shop_name] = this.saleResume.totalByShop[s.shop_name]? this.saleResume.totalByShop[s.shop_name]+s.total : s.total;
                this.saleResume.totalByShop[s.shop_name] = this.roundValue(this.saleResume.totalByShop[s.shop_name]);
                if (!this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name]){
                    this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name] = {
                        total: 0,
                        credit_card: 0,
                        cash: 0,
                        others: 0
                    }
                }
                this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].total += s.total;

                if (s.method_of_payment === "Tarjeta"){
                    this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].credit_card += s.total;
                }else if (s.method_of_payment === "Efectivo"){
                    this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].cash += s.total;
                }else if (s.method_of_payment === "Mixto"){
                    this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].cash += s.total_cash;
                    this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].credit_card += s.total_credit_card;
                }else{
                    this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].others += s.total;
                }
                this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].total = this.roundValue(this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].total);
                this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].credit_card = this.roundValue(this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].credit_card);
                this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].cash = this.roundValue(this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].cash);
                this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].others = this.roundValue(this.saleResume.totalByShopAndUserPaymentMethod[s.user_name +" "+ s.shop_name].others);
            });
            this.saleResume.totalByShopKeys = Object.keys(this.saleResume.totalByShop);
            this.saleResume.totalByShopAndUserPaymentMethodKeys = Object.keys(this.saleResume.totalByShopAndUserPaymentMethod);
        });
    }

    getReturnSales(){
        this.saleReturnResume = {
            shopsTotal: 0,
            totalByShop: [],
            totalByShopAndUser: []
        }
        var params = {
            createdAtFrom:null,
            createdAtUntil: null
        }
        if (this.saleFilter.fromDate && moment(this.saleFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
            params.createdAtFrom = moment(this.saleFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        }
        if (this.saleFilter.untilDate && moment(this.saleFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
            params.createdAtUntil = moment(this.saleFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        }
        this.StatsService.getRevenueSaleReturn(params)
        .subscribe((saleReturn) => {
            saleReturn.forEach((s)=>{
                if (s.shop_id){
                    this.saleReturnResume.shopsTotal += s.total;
                    this.saleReturnResume.shopsTotal = this.roundValue(this.saleReturnResume.shopsTotal);
                    
                    this.saleReturnResume.totalByShop[s.shop_name] = this.saleReturnResume.totalByShop[s.shop_name]? this.saleReturnResume.totalByShop[s.shop_name]+s.total : s.total; 
                    this.saleReturnResume.totalByShop[s.shop_name] = this.roundValue(this.saleReturnResume.totalByShop[s.shop_name]);


                    if (!this.saleReturnResume.totalByShopAndUser[s.user_name +" "+ s.shop_name]){
                        this.saleReturnResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] = 0;
                    }
                    this.saleReturnResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] += s.total;
                    this.saleReturnResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] = this.roundValue(this.saleReturnResume.totalByShopAndUser[s.user_name +" "+ s.shop_name]);
                }
            });
        });
    }

    resetValues(){
        this.saleResume = {
            shopsTotal: 0,
            totalByShop: [],
            totalByShopAndUserPaymentMethod: []
        }
        this.saleReturnResume = {
            shopsTotal: 0,
            totalByShop: [],
            totalByShopAndUser: []
        }
    }

    getStockFilter(){
        let date = this.stockDate;
        this.getStockStats(date)
    }

    getStockStats(date){
        var params = {
            date: date
        };
        this.stockStatsService.query(params).subscribe((result) => {
            this.totals.number_of_products = 0;
            this.totals.total_invested = 0;
            this.totals.total_expected_sales = 0;
            result.forEach((r)=>{
                this.totals.number_of_products += r.number_of_product;
                this.totals.total_invested += r.total_invested;
                this.totals.total_expected_sales += r.total_expected_sales;
            });
            this.stockStats = result;

        });
    }

    roundValue(value){
        return Math.round(value * 100) / 100;
    }

    calculateRevenueExpensesResume(){
        this.revenueResume = {
            shopsTotal: 0,
            totalByShop: [],
            totalByShopAndUser: []
        }
        this.expensesResume = {
            shopsTotal: 0,
            totalByShop: [],
            totalByShopAndUser: []
        }
        this.getRevenue();
        this.getExpenses();
    }


    getRevenue(){
        let sales:any;
        let returns:any;
        let withdrawalRepurchase:any;
        let renewals:any;
        let technicalservices:any;
        this.getRevenueReturnSales(false).then((rs)=>{
            returns = rs;
            this.getRevenueSales(false).then((s)=>{
                sales = s;
                this.getWithdrawalRepurchases(false).then((wr)=>{
                    withdrawalRepurchase = wr;
                    this.getRepurchaseRenewals(false).then((rr)=>{
                        renewals = rr;
                        this.getThecnicalServices(false).then((ts) =>{
                            technicalservices = ts;
                            this.revenueResume.shopsTotal = 0;
                            this.revenueResume.shopsTotal = sales.shopsTotal + returns.shopsTotal + withdrawalRepurchase.shopsTotal + renewals.shopsTotal + technicalservices.shopsTotal;
                            // Total By Shop
                            this.revenueResume.totalByShop = [];
                            for (var key in sales.totalByShop) {
                                if (sales.totalByShop.hasOwnProperty(key)) {
                                    if (!this.revenueResume.totalByShop[key]){
                                        this.revenueResume.totalByShop[key] = 0;
                                    }
                                    this.revenueResume.totalByShop[key] += sales.totalByShop[key];
                                }
                            }
                            for (var key in returns.totalByShop) {
                                if (returns.totalByShop.hasOwnProperty(key)) {
                                    if (!this.revenueResume.totalByShop[key]){
                                        this.revenueResume.totalByShop[key] = 0;
                                    }
                                    this.revenueResume.totalByShop[key] += returns.totalByShop[key];
                                }
                            }
                            for (var key in withdrawalRepurchase.totalByShop) {
                                if (withdrawalRepurchase.totalByShop.hasOwnProperty(key)) {
                                    if (!this.revenueResume.totalByShop[key]){
                                        this.revenueResume.totalByShop[key] = 0;
                                    }
                                    this.revenueResume.totalByShop[key] += withdrawalRepurchase.totalByShop[key];
                                }
                            }
                            for (var key in renewals.totalByShop) {
                                if (renewals.totalByShop.hasOwnProperty(key)) {
                                    if (!this.revenueResume.totalByShop[key]){
                                        this.revenueResume.totalByShop[key] = 0;
                                    }
                                    this.revenueResume.totalByShop[key] += renewals.totalByShop[key];
                                }
                            }
                            for (var key in technicalservices.totalByShop) {
                                if (technicalservices.totalByShop.hasOwnProperty(key)) {
                                    if (!this.revenueResume.totalByShop[key]){
                                        this.revenueResume.totalByShop[key] = 0;
                                    }
                                    this.revenueResume.totalByShop[key] += technicalservices.totalByShop[key];
                                }
                            }
                            this.revenueResume.shopKeys = Object.keys(this.revenueResume.totalByShop);
                            //By Shop and user
                            for (var key in sales.totalByShopAndUser) {
                                if (sales.totalByShopAndUser.hasOwnProperty(key)) {
                                    if (!this.revenueResume.totalByShopAndUser[key]){
                                        this.revenueResume.totalByShopAndUser[key] = {}
                                    }
                                    this.revenueResume.totalByShopAndUser[key].sales = sales.totalByShopAndUser[key];
                                }
                            }
                            for (var key in returns.totalByShopAndUser) {
                                if (returns.totalByShopAndUser.hasOwnProperty(key)) {
                                    if (!this.revenueResume.totalByShopAndUser[key]){
                                        this.revenueResume.totalByShopAndUser[key] = {}
                                    }
                                    this.revenueResume.totalByShopAndUser[key].returns = returns.totalByShopAndUser[key];
                                }
                            }
                            for (var key in withdrawalRepurchase.totalByShopAndUser) {
                                if (withdrawalRepurchase.totalByShopAndUser.hasOwnProperty(key)) {
                                    if (!this.revenueResume.totalByShopAndUser[key]){
                                        this.revenueResume.totalByShopAndUser[key] = {}
                                    }
                                    this.revenueResume.totalByShopAndUser[key].withdrawalRepurchase = withdrawalRepurchase.totalByShopAndUser[key];
                                }
                            }
                            for (var key in renewals.totalByShopAndUser) {
                                if (renewals.totalByShopAndUser.hasOwnProperty(key)) {
                                    if (!this.revenueResume.totalByShopAndUser[key]){
                                        this.revenueResume.totalByShopAndUser[key] = {}
                                    }
                                    this.revenueResume.totalByShopAndUser[key].renewals = renewals.totalByShopAndUser[key];
                                }
                            }
                            for (var key in technicalservices.totalByShopAndUser) {
                                if (technicalservices.totalByShopAndUser.hasOwnProperty(key)) {
                                    if (!this.revenueResume.totalByShopAndUser[key]){
                                        this.revenueResume.totalByShopAndUser[key] = {}
                                    }
                                    this.revenueResume.totalByShopAndUser[key].technicalservices = technicalservices.totalByShopAndUser[key];
                                }
                            }
                            this.revenueResume.shopUserKeys = Object.keys(this.revenueResume.totalByShopAndUser);

                            if (this.expensesResume.shopKeys && this.revenueResume.shopKeys && this.expensesResume.shopKeys.length > 0 && this.revenueResume.shopKeys.length > 0){
                                this.generalShopKeys = this.filterUnique(this.revenueResume.shopKeys.concat(this.expensesResume.shopKeys));
                            }else if (this.expensesResume.shopKeys && this.expensesResume.shopKeys.length > 0){
                                this.generalShopKeys = this.expensesResume.shopKeys;
                            }else if (this.revenueResume.shopKeys && this.revenueResume.shopKeys.length > 0){
                                this.generalShopKeys = this.revenueResume.shopKeys;
                            }
                        });
                    });
                });
            });
        });
    }

    filterUnique(array){
        return array.filter(function (value, index, self) { 
            return self.indexOf(value) === index;
        });
    }

    getExpenses(){
        let purchases:any;
        let repurchases:any;
        let expenses:any;
        this.getExpensesPurchases(false).then((p)=>{
            purchases = p;
            this.getExpensesRepurchases(false).then((r)=>{
                repurchases = r;
                this.getExpensesExpenses(false).then((e)=>{
                    expenses = e;
                    this.expensesResume.shopsTotal = purchases.shopsTotal + repurchases.shopsTotal + expenses.shopsTotal;
                    // Total By Shop
                    this.expensesResume.totalByShop = [];
                    for (var key in purchases.totalByShop) {
                        if (purchases.totalByShop.hasOwnProperty(key)) {
                            if (!this.expensesResume.totalByShop[key]){
                                this.expensesResume.totalByShop[key] = 0;
                            }
                            this.expensesResume.totalByShop[key] += purchases.totalByShop[key];
                        }
                    }
                    for (var key in repurchases.totalByShop) {
                        if (repurchases.totalByShop.hasOwnProperty(key)) {
                            if (!this.expensesResume.totalByShop[key]){
                                this.expensesResume.totalByShop[key] = 0;
                            }
                            this.expensesResume.totalByShop[key] += repurchases.totalByShop[key];
                        }
                    }
                    for (var key in expenses.totalByShop) {
                        if (expenses.totalByShop.hasOwnProperty(key)) {
                            if (!this.expensesResume.totalByShop[key]){
                                this.expensesResume.totalByShop[key] = 0;
                            }
                            this.expensesResume.totalByShop[key] += expenses.totalByShop[key];
                        }
                    }
                    this.expensesResume.shopKeys = Object.keys(this.expensesResume.totalByShop);
                    this.expensesResume.totalByShopAndUser = {};
                    //By Shop and user
                    for (var key in purchases.totalByShopAndUser) {
                        if (purchases.totalByShopAndUser.hasOwnProperty(key)) {
                            if (!this.expensesResume.totalByShopAndUser[key]){
                                this.expensesResume.totalByShopAndUser[key] = {}
                            }
                            this.expensesResume.totalByShopAndUser[key].purchases = purchases.totalByShopAndUser[key];
                        }
                    }
                    for (var key in repurchases.totalByShopAndUser) {
                        if (repurchases.totalByShopAndUser.hasOwnProperty(key)) {
                            if (!this.expensesResume.totalByShopAndUser[key]){
                                this.expensesResume.totalByShopAndUser[key] = {}
                            }
                            this.expensesResume.totalByShopAndUser[key].repurchases = repurchases.totalByShopAndUser[key];
                        }
                    }
                    for (var key in expenses.totalByShopAndUser) {
                        if (expenses.totalByShopAndUser.hasOwnProperty(key)) {
                            if (!this.expensesResume.totalByShopAndUser[key]){
                                this.expensesResume.totalByShopAndUser[key] = {}
                            }
                            this.expensesResume.totalByShopAndUser[key].expenses = expenses.totalByShopAndUser[key];
                        }
                    }
                    this.expensesResume.shopUserKeys = Object.keys(this.expensesResume.totalByShopAndUser);
                    for (var key in this.expensesResume.shopUserKeys) {
                        if (!this.expensesResume.totalByShopAndUser[key] && key){
                            this.expensesResume.totalByShopAndUser[key] = {};
                        }
                        this.expensesResume.totalByShopAndUser[key].total = 0;
                        if (this.expensesResume.totalByShopAndUser[key].purchases)
                            this.expensesResume.totalByShopAndUser[key].total += this.expensesResume.totalByShopAndUser[key].purchases;
                        if (this.expensesResume.totalByShopAndUser[key].repurchases)
                            this.expensesResume.totalByShopAndUser[key].total += this.expensesResume.totalByShopAndUser[key].repurchases;
                        if (this.expensesResume.totalByShopAndUser[key].expenses)
                            this.expensesResume.totalByShopAndUser[key].total += this.expensesResume.totalByShopAndUser[key].expenses;
                    }

                    if (this.expensesResume.shopKeys && this.revenueResume.shopKeys && this.expensesResume.shopKeys.length > 0 && this.revenueResume.shopKeys.length > 0){
                        this.generalShopKeys = this.filterUnique(this.revenueResume.shopKeys.concat(this.expensesResume.shopKeys));
                    }else if (this.expensesResume.shopKeys && this.expensesResume.shopKeys.length > 0){
                        this.generalShopKeys = this.expensesResume.shopKeys;
                    }else if (this.revenueResume.shopKeys && this.revenueResume.shopKeys.length > 0){
                        this.generalShopKeys = this.revenueResume.shopKeys;
                    }
                })
            })
        })
    }

    getTotalRevenueAndExpensesByTrimester(){
        let purchases:any;
        let repurchases:any;
        let expenses:any;
        var trimester = this.selectedTrimester;
        this.getExpensesPurchases(trimester).then((p)=>{
            purchases = p;
            this.getExpensesRepurchases(trimester).then((r)=>{
                repurchases = r;
                this.getExpensesExpenses(trimester).then((e)=>{
                    expenses = e;
                    let totalExpenses = purchases.shopsTotal + repurchases.shopsTotal + expenses.shopsTotal;
                    let sales:any;
                    let returns:any;
                    let withdrawalRepurchase:any;
                    let renewals:any;
                    let technicalservices:any;
                    this.getRevenueReturnSales(trimester).then((rs)=>{
                        returns = rs;
                        this.getRevenueSales(trimester).then((s)=>{
                            sales = s;
                            this.getWithdrawalRepurchases(trimester).then((wr)=>{
                                withdrawalRepurchase = wr;
                                this.getRepurchaseRenewals(trimester).then((rr)=>{
                                    renewals = rr;
                                    this.getThecnicalServices(trimester).then((ts) =>{
                                        technicalservices = ts;
                                        this.getExpectedExpenses(trimester).then((ee:any)=>{
                                            let totalExpectedExpenses = 0;
                                            ee.forEach((e)=>{
                                                if (e.type == 1){
                                                    totalExpectedExpenses += e.amount * 3;
                                                }else if (e.type == 2){
                                                    totalExpectedExpenses += (e.amount * 2) + (e.amount/2);
                                                }else if (e.type == 3){
                                                    totalExpectedExpenses += e.amount;
                                                }
                                            });
                                            let totalRevenue = sales.shopsTotal + returns.shopsTotal + withdrawalRepurchase.shopsTotal + renewals.shopsTotal + technicalservices.shopsTotal;
                                            this.totalRevenueExpensesByTrimester = this.roundValue(totalRevenue - totalExpenses - totalExpectedExpenses);
                                            this.totalRevenueExpensesWithoutExpectedExpenses = this.roundValue(totalRevenue - totalExpenses);
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    };


    getExpectedExpenses(trimester){
        return new Promise((resolve, reject) => {
            var params = {
                where: {}
            };
            var params2 = {
                where: {}
            };
            params.where['valid_from']  = {};
            params.where['valid_until']  = {};
            params2.where['valid_from']  = {};
            params2.where['valid_until']  = {};
            if (trimester === 1){
                params.where['valid_from']["<="] = moment("31-03-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params.where['valid_until']["<="] = moment("31-03-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params.where['valid_until'][">="] = moment("01-01-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params2.where['valid_from']["<="] = moment("31-03-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params2.where['valid_until'] = null;
            }
            if (trimester === 2){
                params.where['valid_from']["<="] = moment("30-06-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params.where['valid_until']["<="] = moment("30-06-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params.where['valid_until'][">="] = moment("01-01-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params2.where['valid_from']["<="] = moment("01-04-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params2.where['valid_until'] = null;
            }
            if (trimester === 3){
                params.where['valid_from']["<="] = moment("30-09-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params.where['valid_until']["<="] = moment("30-09-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params.where['valid_until'][">="] = moment("01-07-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params2.where['valid_from']["<="] = moment("01-07-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params2.where['valid_until'] = null;
            }
            if (trimester === 4){
                params.where['valid_from']["<="] = moment("31-12-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params.where['valid_until']["<="] = moment("31-12-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params.where['valid_until'][">="] = moment("01-10-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params2.where['valid_from']["<="] = moment("01-10-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                params2.where['valid_until'] = null;
            }

            this.expectedExpensesService.query(params)
                .subscribe((expectedEpenses) => {
                    this.expectedExpensesService.query(params2)
                    .subscribe((expectedEpenses2) => {
                        var allExpenses = expectedEpenses.concat(expectedEpenses2);
                        resolve(allExpenses);
                    });
                });
        });
    }


    ////
    getRevenueReturnSales(trimester){
        return new Promise((resolve, reject) => {
            let revenueSaleReturnResume:any = {
                shopsTotal: 0,
                totalByShop: [],
                totalByShopAndUser: []
            }
            var params = {
                createdAtFrom:null,
                createdAtUntil: null
            }
            if (this.revenueFilter.fromDate && moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtFrom = moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (this.revenueFilter.untilDate && moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtUntil = moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (trimester != false){
                if (trimester === 1){
                    params.createdAtFrom = moment("01-01-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-03-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 2){
                    params.createdAtFrom = moment("01-04-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-06-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 3){
                    params.createdAtFrom = moment("01-07-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-09-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 4){
                    params.createdAtFrom = moment("01-10-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-12-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
            }
            this.StatsService.getRevenueSaleReturn(params)
            .subscribe((saleReturn) => {
                saleReturn.forEach((s)=>{
                    revenueSaleReturnResume.shopsTotal += s.total;
                    revenueSaleReturnResume.shopsTotal = this.roundValue(revenueSaleReturnResume.shopsTotal);
                    
                    revenueSaleReturnResume.totalByShop[s.shop_name] = revenueSaleReturnResume.totalByShop[s.shop_name]? revenueSaleReturnResume.totalByShop[s.shop_name]+s.total : s.total; 
                    revenueSaleReturnResume.totalByShop[s.shop_name] = this.roundValue(revenueSaleReturnResume.totalByShop[s.shop_name]);

                
                    if (!revenueSaleReturnResume.totalByShopAndUser[s.user_name +" "+ s.shop_name]){
                        revenueSaleReturnResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] = 0;
                    }
                    revenueSaleReturnResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] += s.total;
                    revenueSaleReturnResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] = this.roundValue(revenueSaleReturnResume.totalByShopAndUser[s.user_name +" "+ s.shop_name]);

                });
                resolve(revenueSaleReturnResume);
            });
        });
    }

    getRevenueSales(trimester){
        return new Promise((resolve, reject) => {
            let revenueSaleResume:any = {
                shopsTotal: 0,
                totalByShop: [],
                totalByShopAndUser: []
            }
            var params = {
                createdAtFrom:null,
                createdAtUntil: null
            }
            if (this.revenueFilter.fromDate && moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtFrom = moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (this.revenueFilter.untilDate && moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtUntil = moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (trimester != false){
                if (trimester === 1){
                    params.createdAtFrom = moment("01-01-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-03-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 2){
                    params.createdAtFrom = moment("01-04-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-06-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 3){
                    params.createdAtFrom = moment("01-07-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-09-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 4){
                    params.createdAtFrom = moment("01-10-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-12-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
            }
            this.StatsService.getRevenueSale(params)
            .subscribe((sales) => {
                sales.forEach((s)=>{
                        revenueSaleResume.shopsTotal += s.total;
                        revenueSaleResume.shopsTotal = this.roundValue(revenueSaleResume.shopsTotal);
                        revenueSaleResume.totalByShop[s.shop_name] = revenueSaleResume.totalByShop[s.shop_name]? revenueSaleResume.totalByShop[s.shop_name]+s.total : s.total;
                        revenueSaleResume.totalByShop[s.shop_name] = this.roundValue(revenueSaleResume.totalByShop[s.shop_name]);
                        if (!revenueSaleResume.totalByShopAndUser[s.user_name  +" "+ s.shop_name]){
                            revenueSaleResume.totalByShopAndUser[s.user_name  +" "+ s.shop_name] = 0;
                        }
                        revenueSaleResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] += s.total;
                        revenueSaleResume.totalByShopAndUser[s.user_name  +" "+ s.shop_name] = this.roundValue(revenueSaleResume.totalByShopAndUser[s.user_name  +" "+ s.shop_name]);
                });
                resolve(revenueSaleResume);
            });
        });
    }


    getWithdrawalRepurchases(trimester){
        return new Promise((resolve, reject) => {
            let revenueWithdrawalRepurchaseResume:any = {
                shopsTotal: 0,
                totalByShop: [],
                totalByShopAndUser: []
            }
            var params = {
                createdAtFrom:null,
                createdAtUntil: null
            }
            if (this.revenueFilter.fromDate && moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtFrom = moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (this.revenueFilter.untilDate && moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtUntil = moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (trimester != false){
                if (trimester === 1){
                    params.createdAtFrom = moment("01-01-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-03-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 2){
                    params.createdAtFrom = moment("01-04-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-06-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 3){
                    params.createdAtFrom = moment("01-07-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-09-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 4){
                    params.createdAtFrom = moment("01-10-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-12-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
            }
            //Esto se debe refactorizar y eliminar la petición a repurchases ya que se hace todo ya a través de repurchaseWithdrawalTicketService, se mantienen los dos por datos historicos.
            this.StatsService.getRevenueWithdrawalRepurchase(params)
            .subscribe((repurchases) => {
                this.StatsService.getRevenueWithdrawalRepurchaseTicket(params)
                .subscribe((repurchasesTickets) => {
                    repurchases = repurchases.concat(repurchasesTickets);
                    repurchases.forEach(r => {
                        revenueWithdrawalRepurchaseResume.shopsTotal += r.total;
                        revenueWithdrawalRepurchaseResume.shopsTotal = this.roundValue(revenueWithdrawalRepurchaseResume.shopsTotal);
                        revenueWithdrawalRepurchaseResume.totalByShop[r.shop_name] = revenueWithdrawalRepurchaseResume.totalByShop[r.shop_name]? revenueWithdrawalRepurchaseResume.totalByShop[r.shop_name]+r.total : r.total;
                        revenueWithdrawalRepurchaseResume.totalByShop[r.shop_name] = this.roundValue(revenueWithdrawalRepurchaseResume.totalByShop[r.shop_name]);
                        if (!revenueWithdrawalRepurchaseResume.totalByShopAndUser[r.user_name  +" "+ r.shop_name]){
                            revenueWithdrawalRepurchaseResume.totalByShopAndUser[r.user_name  +" "+ r.shop_name] = 0;
                        }
                        revenueWithdrawalRepurchaseResume.totalByShopAndUser[r.user_name +" "+ r.shop_name] += r.total;
                        revenueWithdrawalRepurchaseResume.totalByShopAndUser[r.user_name  +" "+ r.shop_name] = this.roundValue(revenueWithdrawalRepurchaseResume.totalByShopAndUser[r.user_name  +" "+ r.shop_name]);
                    });
                    resolve(revenueWithdrawalRepurchaseResume);
                });
            });
        });
    }


    getRepurchaseRenewals(trimester){
        return new Promise((resolve, reject) => {
            let revenueRepurchaseRenewalResume:any = {
                shopsTotal: 0,
                totalByShop: [],
                totalByShopAndUser: []
            }
            var params = {
                createdAtFrom:null,
                createdAtUntil: null
            }
            if (this.revenueFilter.fromDate && moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtFrom = moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (this.revenueFilter.untilDate && moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtUntil = moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (trimester != false){
                if (trimester === 1){
                    params.createdAtFrom = moment("01-01-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-03-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 2){
                    params.createdAtFrom = moment("01-04-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-06-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 3){
                    params.createdAtFrom = moment("01-07-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-09-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 4){
                    params.createdAtFrom = moment("01-10-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-12-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
            }
            this.StatsService.getRevenueRepurchaseRenewals(params)
            .subscribe((renewals) => {
                renewals.forEach(r => {
                    revenueRepurchaseRenewalResume.shopsTotal += r.total;
                    revenueRepurchaseRenewalResume.shopsTotal = this.roundValue(revenueRepurchaseRenewalResume.shopsTotal);
                
                    revenueRepurchaseRenewalResume.totalByShop[r.shop_name] = revenueRepurchaseRenewalResume.totalByShop[r.shop_name]? revenueRepurchaseRenewalResume.totalByShop[r.shop_name]+r.total : r.total; 
                    revenueRepurchaseRenewalResume.totalByShop[r.shop_name] = this.roundValue(revenueRepurchaseRenewalResume.totalByShop[r.shop_name]);
            
                    if (!revenueRepurchaseRenewalResume.totalByShopAndUser[r.user_name +" "+ r.shop_name]){
                        revenueRepurchaseRenewalResume.totalByShopAndUser[r.user_name +" "+ r.shop_name] = 0;
                    }
                    revenueRepurchaseRenewalResume.totalByShopAndUser[r.user_name +" "+ r.shop_name] += r.total;
                    revenueRepurchaseRenewalResume.totalByShopAndUser[r.user_name +" "+ r.shop_name] = this.roundValue(revenueRepurchaseRenewalResume.totalByShopAndUser[r.user_name +" "+ r.shop_name]);
                });
                resolve(revenueRepurchaseRenewalResume);
            });
        });
    }

    getThecnicalServices(trimester){
        return new Promise((resolve, reject) => {
            let revenueTechnicalServiceResume:any = {
                shopsTotal: 0,
                totalByShop: [],
                totalByShopAndUser: []
            }
            var params = {
                createdAtFrom:null,
                createdAtUntil: null
            }
            if (this.revenueFilter.fromDate && moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtFrom = moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (this.revenueFilter.untilDate && moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtUntil = moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (trimester != false){
                if (trimester === 1){
                    params.createdAtFrom = moment("01-01-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-03-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 2){
                    params.createdAtFrom = moment("01-04-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-06-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 3){
                    params.createdAtFrom = moment("01-07-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-09-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 4){
                    params.createdAtFrom = moment("01-10-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-12-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
            }
            this.StatsService.getRevenueTechnicalService(params)
            .subscribe((technicalService) => {
                technicalService.forEach((s)=>{
                    revenueTechnicalServiceResume.shopsTotal += s.total;
                    revenueTechnicalServiceResume.shopsTotal = this.roundValue(revenueTechnicalServiceResume.shopsTotal);
                    
                    revenueTechnicalServiceResume.totalByShop[s.shop_name] = revenueTechnicalServiceResume.totalByShop[s.shop_name]? revenueTechnicalServiceResume.totalByShop[s.shop_name]+s.total : s.total; 
                    revenueTechnicalServiceResume.totalByShop[s.shop_name] = this.roundValue(revenueTechnicalServiceResume.totalByShop[s.shop_name]);

                
                    if (!revenueTechnicalServiceResume.totalByShopAndUser[s.user_name +" "+ s.shop_name]){
                        revenueTechnicalServiceResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] = 0;
                    }
                    revenueTechnicalServiceResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] += s.total;
                    revenueTechnicalServiceResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] = this.roundValue(revenueTechnicalServiceResume.totalByShopAndUser[s.user_name +" "+ s.shop_name]);

                });
                resolve(revenueTechnicalServiceResume);
            });
        });
    }

    getExpensesPurchases(trimester){
        return new Promise((resolve, reject) => {
            let expensesPurchaseResume:any = {
                shopsTotal: 0,
                totalByShop: [],
                totalByShopAndUser: []
            }
            var params = {
                createdAtFrom:null,
                createdAtUntil: null
            }
            if (this.revenueFilter.fromDate && moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtFrom = moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (this.revenueFilter.untilDate && moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtUntil = moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (trimester != false){
                if (trimester === 1){
                    params.createdAtFrom = moment("01-01-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-03-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 2){
                    params.createdAtFrom = moment("01-04-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-06-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 3){
                    params.createdAtFrom = moment("01-07-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-09-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 4){
                    params.createdAtFrom = moment("01-10-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-12-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
            }
            this.StatsService.getExpensesPurchases(params)
            .subscribe((purchases) => {
                purchases.forEach((s)=>{
                    expensesPurchaseResume.shopsTotal += s.total;
                    expensesPurchaseResume.shopsTotal = this.roundValue(expensesPurchaseResume.shopsTotal);
                    expensesPurchaseResume.totalByShop[s.shop_name] = expensesPurchaseResume.totalByShop[s.shop_name]? expensesPurchaseResume.totalByShop[s.shop_name]+s.total : s.total; 
                    expensesPurchaseResume.totalByShop[s.shop_name] = this.roundValue(expensesPurchaseResume.totalByShop[s.shop_name]);
                    if (!expensesPurchaseResume.totalByShopAndUser[s.user_name +" "+ s.shop_name]){
                        expensesPurchaseResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] = 0;
                    }
                    expensesPurchaseResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] += s.total;
                    expensesPurchaseResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] = this.roundValue(expensesPurchaseResume.totalByShopAndUser[s.user_name +" "+ s.shop_name]);
                });
                resolve(expensesPurchaseResume);
            });
       });
    }


    getExpensesRepurchases(trimester){
        return new Promise((resolve, reject) => {
            let expensesRepurchaseResume:any = {
                shopsTotal: 0,
                totalByShop: [],
                totalByShopAndUser: []
            }
            var params = {
                createdAtFrom:null,
                createdAtUntil: null
            }
            if (this.revenueFilter.fromDate && moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtFrom = moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (this.revenueFilter.untilDate && moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtUntil = moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (trimester != false){
                if (trimester === 1){
                    params.createdAtFrom = moment("01-01-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-03-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 2){
                    params.createdAtFrom = moment("01-04-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-06-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 3){
                    params.createdAtFrom = moment("01-07-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-09-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 4){
                    params.createdAtFrom = moment("01-10-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-12-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
            }
            this.StatsService.getExpensesRepurchases(params)
            .subscribe((repurchases) => {
                repurchases.forEach((s)=>{
                    expensesRepurchaseResume.shopsTotal += s.total;
                    expensesRepurchaseResume.shopsTotal = this.roundValue(expensesRepurchaseResume.shopsTotal);
                    expensesRepurchaseResume.totalByShop[s.shop_name] = expensesRepurchaseResume.totalByShop[s.shop_name]? expensesRepurchaseResume.totalByShop[s.shop_name]+s.total : s.total; 
                    expensesRepurchaseResume.totalByShop[s.shop_name] = this.roundValue(expensesRepurchaseResume.totalByShop[s.shop_name]);
                    if (!expensesRepurchaseResume.totalByShopAndUser[s.user_name +" "+ s.shop_name]){
                        expensesRepurchaseResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] = 0;
                    }
                    expensesRepurchaseResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] += s.total;
                    expensesRepurchaseResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] = this.roundValue(expensesRepurchaseResume.totalByShopAndUser[s.user_name +" "+ s.shop_name]);
                });
                resolve(expensesRepurchaseResume);
            });
        });
    }

    getExpensesExpenses(trimester){
        return new Promise((resolve, reject) => {
            let expensesExpensesResume:any = {
                shopsTotal: 0,
                totalByShop: [],
                totalByShopAndUser: []
            }
            var params = {
                createdAtFrom:null,
                createdAtUntil: null
            }
            if (this.revenueFilter.fromDate && moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtFrom = moment(this.revenueFilter.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (this.revenueFilter.untilDate && moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
                params.createdAtUntil = moment(this.revenueFilter.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            if (trimester != false){
                if (trimester === 1){
                    params.createdAtFrom = moment("01-01-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-03-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 2){
                    params.createdAtFrom = moment("01-04-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-06-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 3){
                    params.createdAtFrom = moment("01-07-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("30-09-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                if (trimester === 4){
                    params.createdAtFrom = moment("01-10-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                    params.createdAtUntil = moment("31-12-"+this.selectYear, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
            }
            this.StatsService.getExpensesExpenses(params)
            .subscribe((expenses) => {
                expenses.forEach((s)=>{
                    expensesExpensesResume.shopsTotal += s.total;
                    expensesExpensesResume.shopsTotal = this.roundValue(expensesExpensesResume.shopsTotal);
                    expensesExpensesResume.totalByShop[s.shop_name] = expensesExpensesResume.totalByShop[s.shop_name]? expensesExpensesResume.totalByShop[s.shop_name]+s.total : s.total; 
                    expensesExpensesResume.totalByShop[s.shop_name] = this.roundValue(expensesExpensesResume.totalByShop[s.shop_name]);
                    if (!expensesExpensesResume.totalByShopAndUser[s.user_name +" "+ s.shop_name]){
                        expensesExpensesResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] = 0;
                    }
                    expensesExpensesResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] += s.total;
                    expensesExpensesResume.totalByShopAndUser[s.user_name +" "+ s.shop_name] = this.roundValue(expensesExpensesResume.totalByShopAndUser[s.user_name +" "+ s.shop_name]);
                });
                resolve(expensesExpensesResume);
            });
        });
    }


}


// WEBPACK FOOTER //
// ./src/app/reports/components/stats/stats.component.ts